import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container']
  static values = {
    open: {type: Boolean, default: false}
  }

  connect () {
    document.addEventListener('keydown', this.handleKeyPress.bind(this))
  }

  disconnect () {
    document.removeEventListener('keydown', this.handleKeyPress.bind(this))
  }

  handleKeyPress (event) {
    if (event.key === 'Escape' && this.openValue) {
      this.close()
    }
  }

  open (event) {
    this.openValue = true
    this.dispatch("open")

    const slideshowController = this.application.getControllerForElementAndIdentifier(this.containerTarget, 'slideshow')
    slideshowController.indexValue = event.target.dataset.slideIndex
  }

  close () {
    this.openValue = false
    this.dispatch("close")
    
    const slideshowController = this.application.getControllerForElementAndIdentifier(this.containerTarget, 'slideshow')
    slideshowController.pauseEmbeddedVideos()
  }

  openValueChanged() {
    this.containerTarget.classList.toggle('hidden', !this.openValue)
  }
}
